export enum SocialMediaAccountProperties {
  Link = 'link',
  SocialMediaType = 'socialMediaType',
  Owner = 'owner',
  Id = 'id',
  Created = 'created',
  Updated = 'updated',
  Deleted = 'deleted',
  Version = 'version',
}
export enum SocialMediaAccountMetaProperties {}
